<template>
  <div>
    <router-view :key="key"></router-view>
  </div>
</template>

<script>

  export default {
    name: 'App',

    data() {
      return {}
    },
    methods: {},
    computed: {
        key() {
            return this.$route.name !== undefined? this.$route.name + +new Date(): this.$route + +new Date()
        }
    }
  }
</script>

<style>
  @import "./common/css/my_style.css";
  @import "./common/css/my_class.css";
  body{
    margin:0px;
  }
</style>
